import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Divider,
  FormControlLabel,
  Checkbox,
  Switch,
  Typography,
  Button,
  FormLabel,
  RadioGroup,
  Radio,
  TextField,
} from '@material-ui/core';

import {SIREN_CONFIG, CONFIG_SETTINGS } from "config.js";
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";
import { createMuiTheme } from "@material-ui/core/styles";


const Functionalities = props => {
  const { className,  ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  // const [facilityType, setFacilityType] = React.useState(settingsInfo.facilityType);
  // const [keepOnFall, setKeepOnFall] = React.useState(settingsInfo.keepOnFall == '1' ? true : false);
  // const [facilityType, setFacilityType] = React.useState('facility');
  // const [facilityType, setFacilityType] = React.useState('');
  // const [keepOnFall, setKeepOnFall] = React.useState(false);
  // const [firebaseRoot, setFirebaseRoot] = React.useState('');

  const [displayDeviceHealthCheck, setDisplayDeviceHealthCheck] = React.useState(false);
  const [checkForceRecoveryTimeFromFall, setCheckForceRecoveryTimeFromFall] = React.useState(false);
  const [forceRecoveryTimeFromFall, setForceRecoveryTimeFromFall] = React.useState(30);
  const [checkDetectWakeup, setCheckDetectWakeup] = React.useState(false);
  const [wakeupTimeStart, setWakeupTimeStart] = React.useState('');
  const [wakeupTimeEnd, setWakeupTimeEnd] = React.useState('');


  const facility_id = useSelector((store) => store.user.facility_id);

  // const handleFacilityChange = (event) => {
  //   setFacilityType(event.target.value);
  // }

  // const handleKeepOnFall = (event) => {
  //   setKeepOnFall(event.target.checked);
  // }

  const handleKeepDisplayDeviceHealthCheck = (event) => {
    setDisplayDeviceHealthCheck(event.target.checked);
  }

  const handleCheckForceRecoveryTimeFromFall = (event) => {
    setCheckForceRecoveryTimeFromFall(event.target.checked);
  }

  const handleForceRecoveryTimeFromFall = (event) => {
    setForceRecoveryTimeFromFall(event.target.value);
  }

  const handleDetectWakeup = (event) => {
    console.log(event.target.checked);
    setCheckDetectWakeup(event.target.checked);
  }

  const handleWakeupStart = (event) => {
    setWakeupTimeStart(event.target.value);
  }

  const handleWakeupEnd = (event) => {
    setWakeupTimeEnd(event.target.value);
  }


  // const handleFirebaseRoot = (event) => {
  //   setFirebaseRoot(event.target.value);
  // }


  const handleSaveBtn = (event) => {

    //check hour time

    // console.log(facility_id);
    // console.log(facilityType);
    // console.log(keepOnFall);

    fetch(`${SIREN_CONFIG.HOSTNAME}/settings/settings`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        // facilityType: facilityType,
        // keepOnFall: keepOnFall == true ? 1 : 0,
        // FirebaseRootRef: firebaseRoot
        displayDeviceHealthCheck: displayDeviceHealthCheck == true ? 'on' : 'off',
        checkForceRecoveryTimeFromFall: checkForceRecoveryTimeFromFall == true ? 1 : 0,
        forceRecoveryTimeFromFall: forceRecoveryTimeFromFall,
        checkDetectWakeup : checkDetectWakeup == true ? 'on' : 'off',
        wakeupTimeStart : wakeupTimeStart,
        wakeupTimeEnd: wakeupTimeEnd
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        console.log(responseData);
        if (responseData.resultCode === '000') {
          alert(formatMessage({id:'update_successful'}));
          localStorage.setItem(CONFIG_SETTINGS.DisplayDeviceHealthCheck, displayDeviceHealthCheck == true ? 'on' : 'off');
          localStorage.setItem(CONFIG_SETTINGS.AlertWakeUp, checkDetectWakeup == true ? 'on' : 'off');
          localStorage.setItem(CONFIG_SETTINGS.Wakeup_Start_Time, wakeupTimeStart);
          localStorage.setItem(CONFIG_SETTINGS.Wakeup_End_Time, wakeupTimeEnd);
        } else {
          //에러
          alert(`${formatMessage({id:'settings_update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
        }
      })
      .catch((err) => {
        console.error(err);
        alert(`${formatMessage({id:'settings_update_failed'})}\n${responseData.message}`);
      });
  }


  const loadData = () => {

    fetch(`${SIREN_CONFIG.HOSTNAME}/settings/settings?facility_id=${facility_id}`)
    .then( res => res.json() )
    .then( snapshot => {
      if (snapshot.resultData){

        snapshot.resultData.map( (row) => {

          // console.log(row);

          // if (row.settingName === "facilityType") {
          //   setFacilityType(row.settingValue);
          // }
          // else if (row.settingName === "keppOnFall") {
          //   setKeepOnFall(row.settingValue);
          // }
          // else if (row.settingName === "FirebaseRootRef") {
          //   setFirebaseRoot(row.settingValue);
          // }
          if (row.settingName === "displayDeviceHealthCheck") {
            // console.log(row.settingValue);
            setDisplayDeviceHealthCheck(row.settingValue == 'on' ? true : false);
          }
          else if (row.settingName === "forceRecoveryTimeFromFall"){
            // console.log(row.isValid);
            // console.log(row.settingValue);
            setCheckForceRecoveryTimeFromFall(row.isValid == 1 ? true : false);
            if (row.isValid == 1){
              setForceRecoveryTimeFromFall(row.settingValue);
            }
          }
          else if (row.settingName === "checkDetectWakeup"){
            setCheckDetectWakeup(row.settingValue == 'on' ? true : false);
            setWakeupTimeStart(row.val1 || '');
            setWakeupTimeEnd(row.val2 || '');
          }
        });

      }
    });
  }


  useEffect( () => {
    loadData();
  }, []);




  // useEffect( () =>{
  //   // if (settingsInfo.facilityType != null)
  //     // setFacilityType( settingsInfo.facilityType );

  //   // if (settingsInfo.keepOnFall != null)
  //     // setKeepOnFall( settingsInfo.keepOnFall == '1' ? true : false );


  //     firebase.database().ref('/dashboard/'+ FirebaseRootRef ).child("settings/facilityType").get().then( (snapshot) => {
  //       if(snapshot.exists()){
  //         setFacilityType( snapshot.val() );
  //       }
  //     });


  //     firebase.database().ref('/dashboard/'+ FirebaseRootRef ).child("settings/keepOnFall").get().then( (snapshot) => {
  //       if(snapshot.exists()){
  //         setKeepOnFall( snapshot.val() == '1' ? true : false);
  //       }
  //     });
  // }, []);


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <form>
        <CardHeader
          title={<Typography variant="h4"><FormattedMessage id="environments_settings" /></Typography>}
          subheader={formatMessage({id:'settings_subheader'})}
        />
        <Divider />
        <CardContent>
          <Grid container spacing={6} wrap="wrap">

            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <Typography gutterBottom variant="h5" style={{fontWeight:600}}>
                 <FormattedMessage id="settings_dashboard" />
              </Typography>

              <FormControlLabel
                control={<Checkbox color="primary" checked={ displayDeviceHealthCheck }  onChange={handleKeepDisplayDeviceHealthCheck}/>}
                label={<Typography variant="body1">{formatMessage({id:'settings_on_device_check'})}</Typography>}
              />
            </Grid>


            <Grid className={classes.item} container item md={12} sm={12} xs={12}>
              <Typography gutterBottom variant="h5" style={{fontWeight:600}}>
                 <FormattedMessage id="settings_force_auto_recovery_from_fall" />
              </Typography>

              <Grid alignContent="center" direction="row">
                <FormControlLabel
                  style={{ minHeight: 60, minWidth: 160 }}
                  control={<Checkbox color="primary" checked={ checkForceRecoveryTimeFromFall }  onChange={handleCheckForceRecoveryTimeFromFall}/>}
                  label={<Typography variant="body1">{formatMessage({id:'settings_on_force_auto_recovery_from_fall'})}</Typography>}
                />

                <TextField
                  // style={{marginTop: 20}}
                  label={formatMessage({id:'settings_time_force_auto_recovery'})}
                  name="forceRecoveryTimeFromFall"
                  onChange={handleForceRecoveryTimeFromFall}
                  type="text"
                  value={forceRecoveryTimeFromFall}
                  variant="outlined"
                  disabled={!checkForceRecoveryTimeFromFall}
                />
              </Grid>
            </Grid>


            <Grid className={classes.item} container item md={12} sm={12} xs={12}>
              <Typography gutterBottom variant="h5" style={{fontWeight:600}}>
                 <FormattedMessage id="settings_wakeup_detect" />
              </Typography>


              <Grid alignContent="center" direction="row">

                <FormControlLabel
                  style={{ minHeight: 60, minWidth: 160 }}
                  control={<Checkbox color="primary" checked={ checkDetectWakeup }  onChange={handleDetectWakeup}/>}
                  label={<Typography variant="body1">{formatMessage({id:'settings_wakeup_alarm'})}</Typography>}
                />


                <TextField
                  id="time-picker-dialog_start"
                  label={formatMessage({id:'settings_wakeup_time_start'})}
                  type="time"
                  value={wakeupTimeStart}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step:600, //10-min
                  }}
                  onChange={handleWakeupStart}
                  format="HH:mm"
                  disabled={!checkDetectWakeup}
                />

                {/* <TextField
                  label={formatMessage({id:'settings_wakeup_time_start'})}
                  name="wakeup_time_start"
                  onChange={handleWakeupStart}
                  type="text"
                  value={wakeupTimeStart}
                  variant="outlined"
                  disabled={!checkDetectWakeup}
                /> */}
                ~
                <TextField
                  id="time-picker-dialog_end"
                  label={formatMessage({id:'settings_wakeup_time_end'})}
                  type="time"
                  value={wakeupTimeEnd}
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step:600, //10-min
                  }}
                  onChange={handleWakeupEnd}
                  format="HH:mm"
                  disabled={!checkDetectWakeup}
                />
                {/* <TextField
                  label={formatMessage({id:'settings_wakeup_time_end'})}
                  name="wakup_time_end"
                  onChange={handleWakeupEnd}
                  type="text"
                  value={wakeupTimeEnd}
                  variant="outlined"
                  disabled={!checkDetectWakeup}
                /> */}
              </Grid>

              {/* <Grid alignContent="center" direction="row">
              <FormControlLabel
                style={{ minHeight: 60, minWidth: 160 }}
                control={<Checkbox color="primary" checked={ detectWakeup }  onChange={handleDetectWakeup}/>}
                label={<Typography variant="body1">{formatMessage({id:'settings_on_force_auto_recovery_from_fall'})}</Typography>}
              />

              <TextField
                // style={{marginTop: 20}}
                label={formatMessage({id:'settings_time_force_auto_recovery'})}
                name="forceRecoveryTimeFromFall"
                onChange={handleForceRecoveryTimeFromFall}
                type="text"
                value={forceRecoveryTimeFromFall}
                variant="outlined"
                disabled={!checkForceRecoveryTimeFromFall}
              />
              </Grid> */}
            </Grid>

            {/* <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <Typography gutterBottom variant="h6" style={{fontWeight:600}}>
                 낙상 기능
              </Typography>

              <FormLabel component="legend">시설 구분</FormLabel>
              <RadioGroup row aria-label="facilities" name="facilities" value={facilityType} onChange={handleFacilityChange}>
                <FormControlLabel value="facility" control={<Radio color="primary" />} label={<Typography variant="body1">요양시설<Typography variant="body2">장애물 등을 고려하여 센서 감도를 낮춤</Typography></Typography>} />

                <FormControlLabel value="house" control={<Radio color="primary" />} label={<Typography variant="body1">재가환경<Typography variant="body2">클린환경 등을 고려하여 센서 감도를 높임</Typography></Typography>} />
              </RadioGroup>


              <FormControlLabel
                control={<Checkbox color="primary" checked={ keepOnFall == true ? true : false}  onChange={handleKeepOnFall}/>}
                label={<Typography variant="body1">'낙상' 이벤트 발생시, 관리자가 조치를 취하기 전까지, '낙상' 상태 지속함</Typography>}
              />
              <Typography style={{marginLeft: 36  }}variant="body2">'낙상'가 발생할 때마다, 확인 과정이 필요한 경우에 추천</Typography>

              <TextField
                style={{marginTop: 20}}
                fullWidth
                label="FirebaseRoot"
                name="password"
                onChange={handleFirebaseRoot}
                type="text"
                value={firebaseRoot}
                variant="outlined"
              />

            </Grid> */}

          </Grid>
        </CardContent>

        <Divider />

        <CardActions>
          <Button
            color="primary"
            variant="outlined"
            // size="large"
            onClick={handleSaveBtn}
          >
            <FormattedMessage id="save" />
          </Button>
        </CardActions>
      </form>
    </Card>
  );
};

Functionalities.propTypes = {
  className: PropTypes.string,
};

export default Functionalities;


const theme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      input: {
        //   background: '#dd7711',
        //   padding: 10,
        fontSize: '16px',
      },
    },
  },
})



const useStyles = makeStyles(() => ({
  root: {},
  item: {
    display: 'flex',
    flexDirection: 'column'
  },
  textField: {
    marginLeft : theme.spacing(1),
    maringRight: theme.spacing(1),
    width:120,
  },

}));
